import type { QueryClient } from "@tanstack/react-query";

import { featureFlagQueryKeys } from "./featureFlagQueryKeys";

/**
 * Refetch the flag states for the org that has just become current. A mounted
 * reader refetches immediately; with none mounted, the cached matrix is marked
 * stale so the next read fetches it.
 *
 * Call after writing the new org to storage, since both flag fetchers read the
 * current org when they run. A fetch already in flight is still asking for the
 * previous org, and a refetch joins an in-flight fetch that has no data yet
 * rather than starting its own, so cancel that fetch first. Cancelling restores
 * the state the query held before the fetch began. That keeps already-cached
 * states on screen, and it is why the cancel comes first: an invalidation made
 * ahead of it would be wiped.
 */
export async function refetchFeatureFlagStates(
  queryClient: QueryClient,
): Promise<void> {
  const queryKey = featureFlagQueryKeys.states();
  await queryClient.cancelQueries({ queryKey });
  await queryClient.invalidateQueries({ queryKey });
}
